<template>
  <v-app>
    <!--  Loading -->
    <v-dialog
      v-model="showLoading"
      persistent
      max-width="600px"
      overlay-opacity="overlay-opacity"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Cargando contenido, por favor espere.
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--  Alert error -->
    <div class="text-center">
      <v-dialog v-model="showAlertError" persistent width="500">
        <v-card>
          <v-card-title class="headline red accent-4" primary-title>
            Error
          </v-card-title>
          <v-card-text>
            {{ mensajeError }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" text @click="cerrarShowAlertError()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- TAB -->
    <v-card class="mt-1 mb-2 mx-1 pa-0 text-center">
      <v-app-bar
        app
        color="primary"
        :class="$vuetify.breakpoint.smAndDown ? 'pr-2' : ''"
      >
        <v-tabs
          v-model="activeTab"
          fixed-tabs
          center-active
          centered
          background-color="primary"
          slider-color="white"
        >
          <v-tab
            v-for="tabItem in tabsItems"
            :key="tabItem.titulo"
            :href="tabItem.href"
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'caption text-capitalize text-white'
                : 'text-white'
            "
          >
            <v-badge
              v-if="tabItem.titulo === 'Compras' && showNotificaciones"
              color="deep-orange darken-4"
              :content="showNotificaciones ? notificaciones.length : false"
            >
              {{ tabItem.titulo }}
            </v-badge>
            <div v-else>
              {{ tabItem.titulo }}
            </div>
          </v-tab>
        </v-tabs>
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn
              color="error"
              :x-small="$vuetify.breakpoint.smAndDown"
              :small="$vuetify.breakpoint.sm"
              fab
              dark
              v-bind="attrs"
              v-on="on"
              @click="logout()"
            >
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </template>
          <span>Cerrar Sesión</span>
        </v-tooltip>
        <v-spacer />
      </v-app-bar>
      <v-main>
        <!--Contenido de los tabs -->
        <v-tabs-items
          :value="activeTab"
          class="mx-2 my-4"
          @change="tabItemChangeHandler"
        >
          <v-tab-item key="tab-estadisticas" value="tab-estadisticas">
            <Estadisticas :user="user" />
          </v-tab-item>
          <v-tab-item key="tab-presupuestos" value="tab-presupuestos">
            <Presupuestos />
          </v-tab-item>
          <v-tab-item key="tab-ordenes-compras" value="tab-ordenes-compras">
            <OrdenesCompras :observaciones="notificaciones" />
          </v-tab-item>
          <v-tab-item key="tab-perfil" value="tab-perfil">
            <Perfil :user="user" />
          </v-tab-item>
        </v-tabs-items>
      </v-main>
    </v-card>
  </v-app>
</template>
<script>
import { mdiInformation, mdiArrowRight } from '@mdi/js'
import autenticacion from '~/services/autenticacion'
import serviceOrdenCompra from '~/services/serviceOrdenCompra'
import Estadisticas from '~/components/prestador/Estadisticas.vue'
import OrdenesCompras from '~/components/prestador/OrdenesCompras.vue'
import Perfil from '~/components/prestador/Perfil.vue'
import Presupuestos from '~/components/prestador/Presupuestos.vue'
import serviceUsuario from '~/services/serviceUsuario'
import { iniciarMouseFlow } from '~/services/mouseFlow'

export default {
  name: 'Prestador',
  components: {
    Perfil,
    Presupuestos,
    OrdenesCompras,
    Estadisticas
  },
  data() {
    return {
      icons: { mdiInformation, mdiArrowRight },
      user: {},
      datos: {},
      notificaciones: [],
      showLoading: false,
      showAlertError: false,
      showNotificaciones: false,
      mensajeError: '',
      mostrarDatos: false,
      tabsItems: [
        { titulo: 'Estadísticas', href: '#tab-estadisticas' },
        { titulo: 'Presupuestos', href: '#tab-presupuestos' },
        { titulo: 'Compras', href: '#tab-ordenes-compras' },
        { titulo: 'Mi Perfil', href: '#tab-perfil' }
      ],
      activeTab: 'tab-estadisticas'
    }
  },
  watch: {
    '$route.query.tab'(newValue, oldValue) {
      // eslint-disable-next-line no-console
      console.log('🔵 WATCHER: $route.query.tab cambió')
      // eslint-disable-next-line no-console
      console.log('  - Valor anterior:', oldValue)
      // eslint-disable-next-line no-console
      console.log('  - Valor nuevo:', newValue)
      // eslint-disable-next-line no-console
      console.log('  - activeTab actual:', this.activeTab)

      if (this.activeTab !== newValue) {
        // eslint-disable-next-line no-console
        console.log('  ⚠️  Actualizando activeTab a:', newValue)
        this.activeTab = newValue
        // eslint-disable-next-line no-console
        console.log('  - activeTab después de asignar:', this.activeTab)
      } else {
        // eslint-disable-next-line no-console
        console.log(
          '  ✅ NO se actualiza activeTab (ya tiene el valor correcto)'
        )
      }
    },
    activeTab(newValue, oldValue) {
      // eslint-disable-next-line no-console
      console.log('🟢 WATCHER: activeTab cambió')
      // eslint-disable-next-line no-console
      console.log('  - Valor anterior:', oldValue)
      // eslint-disable-next-line no-console
      console.log('  - Valor nuevo:', newValue)
      // eslint-disable-next-line no-console
      console.log('  - $route.query.tab:', this.$route.query.tab)
      // eslint-disable-next-line no-console
      console.log(
        '  - Condición (tab !== activeTab):',
        this.$route.query.tab !== this.activeTab
      )

      // Guardar el tab activo en localStorage
      if (newValue) {
        localStorage.setItem('activeTab', newValue)
        // eslint-disable-next-line no-console
        console.log('  💾 Tab guardado en localStorage:', newValue)
      }

      if (this.$route.query.tab !== this.activeTab) {
        // eslint-disable-next-line no-console
        console.log('  ⚠️  EJECUTANDO $router.replace()')
        // this.$router.replace({
        //   query: { ...this.$route.query, tab: this.activeTab }
        // })
      } else {
        // eslint-disable-next-line no-console
        console.log('  ✅ NO se ejecuta $router.replace()')
      }
    }
  },
  created() {
    // eslint-disable-next-line no-console
    console.log('🟡 CREATED: Inicializando componente')
    // eslint-disable-next-line no-console
    console.log('  - $route.query.tab:', this.$route.query.tab)
    // eslint-disable-next-line no-console
    console.log('  - activeTab inicial:', this.activeTab)

    if (typeof this.$route.query.tab === 'undefined') {
      // eslint-disable-next-line no-console
      console.log('  ⚠️  No hay tab en la URL, estableciendo predeterminado')
      // this.$router.replace({
      //   query: { ...this.$route.query, tab: 'tab-estadisticas' }
      // })
    } else {
      // eslint-disable-next-line no-console
      console.log('  ✅ Tab encontrado en URL:', this.$route.query.tab)
    }
    this.getUsuario()
    this.getNotificaciones()
  },
  mounted() {
    // eslint-disable-next-line no-console
    console.log('🟣 MOUNTED: Componente montado')
    // eslint-disable-next-line no-console
    console.log('  - $route.query.tab:', this.$route.query.tab)
    // eslint-disable-next-line no-console
    console.log('  - activeTab:', this.activeTab)

    if (this.$config.enableMouseflow === true) {
      iniciarMouseFlow(this.$config.urlMouseflow)
    }

    // Cargar el tab desde localStorage
    const savedTab = localStorage.getItem('activeTab')
    // eslint-disable-next-line no-console
    console.log('  - Tab guardado en localStorage:', savedTab)

    if (
      typeof this.$route.query.tab !== 'undefined' &&
      this.$route.query.tab !== this.activeTab
    ) {
      // eslint-disable-next-line no-console
      console.log(
        '  ⚠️  Asignando tab desde URL a activeTab:',
        this.$route.query.tab
      )
      this.activeTab = this.$route.query.tab
      // eslint-disable-next-line no-console
      console.log('  - activeTab después de asignar:', this.activeTab)
    } else if (savedTab && savedTab !== 'undefined') {
      // Si no hay tab en la URL pero hay uno guardado en localStorage, usarlo
      // eslint-disable-next-line no-console
      console.log('  ⚠️  Asignando tab desde localStorage:', savedTab)
      this.activeTab = savedTab
      // eslint-disable-next-line no-console
      console.log(
        '  - activeTab después de asignar desde localStorage:',
        this.activeTab
      )
    } else {
      // eslint-disable-next-line no-console
      console.log('  ✅ NO se asigna activeTab (ya tiene el valor correcto)')
    }
  },
  methods: {
    cerrarShowAlertError() {
      this.mensajeError = ''
      this.showAlertError = false
    },
    async getUsuario() {
      await serviceUsuario
        .check(this.$config.axiosParams)
        .then((response) => {
          this.user = response.data
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            this.$router.push('/login')
          } else {
            this.mensajeError = `Error al obtener los datos del usuario. ${error}`
            this.showAlertError = true
          }
        })
    },
    async getNotificaciones() {
      const busqueda = {
        status: [3]
      }
      try {
        const response = await serviceOrdenCompra.notificaciones(
          this.$config.axiosParams,
          busqueda
        )
        this.notificaciones = Object.keys(response.data).map((idCompra) => {
          return {
            ...response.data[idCompra]
          }
        })
        this.showNotificaciones = this.notificaciones.length > 0
      } catch (error) {
        if (error.response?.status === 401) {
          this.$router.push('/login')
        } else {
          this.notificaciones = []
          this.showLoading = false
          this.showAlertError = true
          this.mensajeError = `Error al obtener las observaciones sin responder de las compras. ${error}`
        }
      }
    },
    async logout() {
      try {
        await autenticacion.logout(this.$config.axiosParams)
        this.$router.push('/login')
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          this.mensajeError = `Error al querer cerrar sesion. ${error}`
          this.showAlertError = true
        }
      }
    },
    tabItemChangeHandler(key) {
      // eslint-disable-next-line no-console
      console.log('🟠 tabItemChangeHandler llamado')
      // eslint-disable-next-line no-console
      console.log('  - key recibido:', key)
      // eslint-disable-next-line no-console
      console.log('  - $route.query.tab:', this.$route.query.tab)
      // eslint-disable-next-line no-console
      console.log('  - activeTab actual:', this.activeTab)

      if (this.$route.query.tab !== key) {
        // eslint-disable-next-line no-console
        console.log('  ⚠️  Cambiando activeTab a:', key)
        this.activeTab = key
      } else {
        // eslint-disable-next-line no-console
        console.log('  ✅ NO se cambia activeTab (ya es igual)')
      }
    }
  }
}
</script>
<style>
.bgcolor-tab {
  background-color: #3f51b5;
}
.bgcolor-tab-item {
  background-color: #e8eaf6;
}
</style>
